<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Co Scholastic</h4>
                    <div class="card-body text-justify">
                        <h5>Co-CURRICULAR AND EXTRA CURRICULAR ACTIVITIES</h5>
                        <hr class="pb-1 rounded">
                        <p class="lead text-justify inner-lead">The School recognizes the significance of supplementing classroom teaching with activities that enhance the learning process and help children discover their talent.
                             Besides providing facilities and opportunities, the children are encouraged to enthusiastically participate in these activities so as to help them develop wholesome personalities.
                              Most of Saturdays are kept aside for such activities and competitions.
                             Teams are sent for various inter-school competitions as well.</p>
                             <a href=" https://youtube.com/@mppsbillboard9392" target="_blank" class="btn btn-warning">Click Here</a>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>